import { useEffect, useState } from "react";
import { useGetCoursesBySchoolByQueryQuery } from "../../../graphql/generated/graphql";
import SearchListModal from "../../../components/common/SearchListModal/SearchListModal";
import { useAppConfig } from "../../../AppConfigProvider";
import { PlusCircle } from "../../../components/svgIcons";

const AssignCourseToFacultyListContainer = ({
  visible,
  onClose,
  onAction,
}: {
  visible: boolean;
  onClose: () => void;
  onAction: (id: string) => void;
}) => {
  const [searchQuery, setSearchQuery] = useState("");
  const appConfig = useAppConfig();
  const schoolId = appConfig.axioSchools[0];

  const { data: coursesData, refetch: coursesRefetch } = useGetCoursesBySchoolByQueryQuery({
    variables: {
      schoolId,
      searchQuery,
      page: 1,
      pageSize: 5,
    },
  });

  useEffect(() => {
    coursesRefetch();
  }, [searchQuery]);

  const list =
    coursesData?.getCoursesBySchoolByQuery?.data.courses.map((course) => {
      return {
        id: course.id,
        name: course.name,
      };
    }) || [];

  return (
    <SearchListModal
      visible={visible}
      onClose={onClose}
      onAction={onAction}
      list={list}
      searchQuery={searchQuery}
      setSearchQuery={setSearchQuery}
      title={"Assign Course"}
      actionLabel="Assign"
      actionIcon={<PlusCircle color="#3E68FE" />}
    />
  );
};

export default AssignCourseToFacultyListContainer;
